"use client";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import * as classNames from "classnames";

import { Tab } from "@headlessui/react";

import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import { getHighlighterTabs } from "@/mock/highlighter";

import ListingWrapper from "components/homepage/highlighter-tab-panels/listing-wrapper";

import styles from "./styles.module.css";

const HighlighterTabWrapper = ({ lastView, allHighlighterTabListingInfo }) => {
  const [selectedTabKey, setSelectedTabKey] = useState(null);

  const handleTabSelect = (highlighterTabName, tabKey) => {
    const eventStaticLabel = `${lastView === "Arsa" ? "arsa-mi" : "ev-mi"}-ariyorsun`;
    const highlighterTabEvent = highlighterTabName === "one-cikanlar" ? "vitrin-ilanlari" : highlighterTabName;
    Ga4WithEventParameters({
      eventName: "click_widget",
      eventParameters: { widget: `${eventStaticLabel}||${highlighterTabEvent}` },
    });
    setSelectedTabKey(tabKey);
  };

  const { tabNames, tabListings } = getHighlighterTabs(lastView, allHighlighterTabListingInfo);

  useEffect(() => {
    const initialSelectedTab = lastView === "Arsa" ? "priceDownSaleListings" : "featuredListings";
    setSelectedTabKey(initialSelectedTab);
  }, [lastView]);

  return (
    <Tab.Group>
      <Tab.List className={styles.tabList}>
        {tabNames?.map((highlighterTabName, index) => (
          <Tab
            key={`${highlighterTabName}-${index}`}
            className={({ selected }) => `${styles.tab} ${selected ? styles.tabselected : styles.tabnotselected}`}
            onClick={() => handleTabSelect(highlighterTabName.ga4Event, highlighterTabName.tabKey)}
          >
            {highlighterTabName.tabName}
          </Tab>
        ))}
      </Tab.List>
      <div className={styles.tabPanels}>
        {tabListings.map((tabItem, index) => {
          const { tabKey, isVisible, getListings, badgeKey, eventLabel, seeAllListingHref, tabTitle } = tabItem;
          if (isVisible) {
            return (
              <div
                className={classNames(styles.tabPanelWrap, { [styles.tabPanelWrapVisible]: tabKey === selectedTabKey })}
                key={tabKey}
              >
                <ListingWrapper
                  getListings={getListings}
                  tabKey={tabKey}
                  badgeKey={badgeKey}
                  eventLabel={eventLabel}
                  seeAllListingHref={seeAllListingHref}
                  tabTitle={tabTitle}
                />
              </div>
            );
          }
          return null;
        })}
      </div>
    </Tab.Group>
  );
};

HighlighterTabWrapper.propTypes = {
  lastView: PropTypes.string,
  allHighlighterTabListingInfo: PropTypes.object,
};

export default HighlighterTabWrapper;
